import _ from 'lodash';

export default class CMSServiceImp {

  public static readonly DEFAULT_IMG_LINK_SIZE = 32;
}
